import React from "react";
import {NavLink } from "react-router-dom";


function TopButton() {
    return ( <NavLink to="#" className="back-to-top">
    <i className="fas fa-long-arrow-alt-up"></i>
</NavLink> );
}

export default TopButton;